// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/js/lib.js"], function() { return __webpack_require__("./assets/js/index.js"); })
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
